<template>
  <form-label-group :label="calcLabel" class="mb-2">
    <b-form-select
      ref="field"
      :value="value"
      :options="options"
      :disabled="disabled"
      :readonly="readonly"
      :placeholder="placeholder"
      :required="required"
      :text-field="textField"
      :value-field="valueField"
      :size="size"
      :class="['form-select', { [`form-select-${size}`]: !!size }]"
      @input="$emit('input', $event)"
    />
  </form-label-group>
</template>

<script>
/**
 * @todo For some reason classes `form-select` and `form-select-[size]` were missing so I had to add them manually.
 * Where these classes came from? Seems like not from Bootstrap.
 */
import FormLabelGroup from '@/components/organisation/FormLabelGroup';

export default {
  name: 'BCustomDropdown',

  components: {
    FormLabelGroup,
  },

  props: {
    value: null,
    options: Array,
    label: String,
    placeholder: String,
    required: Boolean,
    readonly: Boolean,
    disabled: Boolean,
    textField: String,
    valueField: String,
    size: {
      type: String,
      default: 'lg',
    },
  },

  computed: {
    calcLabel() {
      return this.value ? '' : `${this.label}${this.required ? ' *' : ''}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/organisation/BCustomDropdown.vue